import React, { useContext, useEffect, useState } from 'react'
import Layout from '../../Component/layout/main-layout'
import { GetCodexTable } from '../../api/Queries/get'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import Loading from '../../Component/loader/loader'
import { Context } from '../../Store/context';
import layoutBgImg from '../../Images/layout/laws.JPG'

const CodexTable = () => {
    const location = useLocation().pathname.split('/')[2];
    const [codex, setCodex] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const { i18n, t } = useTranslation();
    const { showError } = useContext(Context);

    useEffect(() => {
        setIsLoading(true)
        const getCodex = async () => {
            try {
                const res = await GetCodexTable(location)
                setIsLoading(false)
                setCodex(res.data)
            } catch (error) {
                showError(error.message);
                setIsLoading(false)
            }
        }
        getCodex()
    }, [location, showError])

    const getLawPdf = (laws) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return laws.rus_pdf;
        } else if (currentLang === 'en') {
            return laws.eng_pdf;
        }
        return laws.tm_pdf;
    };

    const pdf = getLawPdf(codex)

    return (
        <div className='mb-20'>
            <Layout
                title={t('laws_codes')}
                page={t('tm_codex')}
                layoutBgImg={layoutBgImg}
            />
            <main className='media'>
                <div className='bg-white border border-secondary 
                                dark:border-dark-border mt-8 p-2 w-full
                                dark:bg-dark-box dark:text-dark-text'>
                    {isLoading ? <Loading /> :
                       <div className='h-[1000px] max-h-max'>
                       <iframe
                           src={`${pdf}#toolbar=0&navpanes=0&view=FitH`}
                           className="w-full h-full"
                           frameBorder="0"
                           title="PDF Viewer"
                       ></iframe>
                   </div>
                    }
                </div>
            </main>
        </div>
    )
}

export default CodexTable
